(function(api) {
	api.ZatvoriRad = ZatvoriRad;
	api.UgovorUpisiZaRad = UgovorUpisiZaRad;
	api.UpdateUgovorSati = UpdateUgovorSati;
	api.GetPonudaSFields = GetPonudaSFields;
	api.GetRacunSFields = GetRacunSFields;
	api.DohvatiDatotekuZaPotpisSC = DohvatiDatotekuZaPotpisSC;
	api.PotpisiCertilia = PotpisiCertilia;
	api.PotpisiCertiliaSkupnoWeb = PotpisiCertiliaSkupnoWeb;	
	api.ZapisiAutoCertilia = ZapisiAutoCertilia;	
	api.upisiFormDataCertilia = upisiFormDataCertilia;	
	api.upisiFormDataCertiliaUgo = upisiFormDataCertiliaUgo; 
	api.VecPostojiTakavUgovor = VecPostojiTakavUgovor; 
	
	api.GetOcSPVrstaSFields = GetOcSPVrstaSFields;
	api.DajPodatkeOOcjenama = DajPodatkeOOcjenama;
	
	api.GetOcSPUgovorSOFields = GetOcSPUgovorSOFields;
	
	function GetOcSPUgovorSOFields(ocspugovors){
			return $.dsDirectCall({
				method: "GetOcSPUgovorSOFields",
				params: [ocspugovors]
			});
		}

	function DajPodatkeOOcjenama(iStudent, iPartner) {
			return $.dsDirectCall({
	            method: "DajPodatkeOOcjenama",
	            params: [iStudent, iPartner]
	        });
		}
	
	function GetOcSPVrstaSFields(ocspvrsta){
		return $.dsDirectCall({
			method: "GetOcSPVrstaSFields",
			params: [ocspvrsta]
		});
	}

	function VecPostojiTakavUgovor(iStudent, iPartner, dOdDanaPlan, dDoDanaPlan) {
		return $.dsDirectCall({
            method: "VecPostojiTakavUgovor",
            params: [iStudent, iPartner, dOdDanaPlan, dDoDanaPlan]
        });
	}	
	function ZapisiAutoCertilia(iAutoCertilia) {
		return $.dsDirectCall({
            method: "ZapisiAutoCertilia",
            params: [iAutoCertilia]
        });
	}	

	function PotpisiCertilia(iGodina, iUgovor, mobilniPotpis, statusNovi, sNapomena) {
		return $.dsDirectCall({
            method: "PotpisiCertilia",
            params: [iGodina, iUgovor, mobilniPotpis, statusNovi, sNapomena]
        });
	}

	function PotpisiCertiliaSkupnoWeb(godina, ugovori, mobilniPotpis, statusNovi, sNapomena) {
		return $.dsDirectCall({
            method: "PotpisiCertiliaSkupnoWeb",
            params: [godina, ugovori, mobilniPotpis, statusNovi, sNapomena]
        });
	}

	function DohvatiDatotekuZaPotpisSC(godina, ugovor, statusNovi) { 
		return $.dsDirectCall({
            method: "DohvatiDatotekuZaPotpisSC",
            params: [godina, ugovor, statusNovi]
        });
	}
	
    function upisiFormDataCertilia(obj, dokdat, errorOverride){
        return $.dsDirectCallPost({
            method: "upisiFormDataCertilia/" + dokdat,
            controller: "ugovor",
            params: [ ],
            data: [ obj, dokdat ],
            fail: function (error, textStatus, jqXHR, logicalError){ 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
            }
        });         
    }

    function upisiFormDataCertiliaUgo(obj, godina, ugovori, errorOverride){
        return $.dsDirectCallPost({
            method: "upisiFormDataCertiliaUgo/" + godina + "/" + ugovori,
            controller: "ugovor",
            params: [ ],
            data: [ obj, godina, ugovori ],
            fail: function (error, textStatus, jqXHR, logicalError){ 
                if (errorOverride){
                    jqXHR.statusText = "errorOverride"; 
                }
            }
        });         
    }

	function ZatvoriRad(rad) {
		return $.dsDirectCall({ 
			method: "sc/ZatvoriRad",
			params: [rad]
		});
	}
	
	function UgovorUpisiZaRad(rad) {
		return $.dsDirectCall({ 
			method: "sc/UgovorUpisiZaRad",
			params: [rad]
		});
	}

	function UpdateUgovorSati(data, errorCB, doneCB) {
		return $.ajax({
	        url: kontorouter.getModulPath('ugovor/satiUpdate'),
	        type: "POST",
			data: data,
	        dataType: "json",
	    })
		.error(errorCB)
	    .done(doneCB);
	}
	
	function GetPonudaSFields(){
		return $.dsDirectCall({
			method: "GetPonudaSFields"
		});
	}
	function GetRacunSFields(){
		return $.dsDirectCall({
			method: "GetRacunSFields"
		});
	}
	
  	
} (konto.sc.api = {}));